export default __webpack_public_path__ + "static/media/ucd.0fa63af0.svg";